import { object } from "prop-types"
import { Router } from "@reach/router"
import { FullscreenLayout } from "source/shared/Layout"
import Confirmation from "./Confirmation"

const Registrations = ({ location }) => {
  return (
    <FullscreenLayout>
      <Router basepath="/registrations/registrations">
        <Confirmation
          path=":registrationId/confirmation"
          isNotificationShowing={location.state.showNotification}
        />
      </Router>
    </FullscreenLayout>
  )
}

Registrations.propTypes = {
  location: object,
}

export default Registrations
